import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {BrowserModule} from '@angular/platform-browser';
import {TranslateModule} from '@ngx-translate/core';
import {BusyIndicatorComponent} from './busy-indicator/busy-indicator.component';
import {CircleProgressbarComponent} from './circle-progressbar/circle-progressbar.component';
import {DataPickerComponent} from './data-picker/data.picker.component';
import {DatepickerCustomHeaderModule} from './datepicker-custom-header/datepicker-custom-header.module';
import {DisableControlDirective} from './disable-control.directive';
import {ImageDefaultDirective} from './image-default.directive';
import {PercentFormatterDirective} from './percent-formatter.directive';
import {PercentInputComponent} from './percent-input/percent-input.component';
import {PercentPipe} from './percent.pipe';
import {SafePipe} from './safe.pipe';
import {InfoDialogComponent} from './info-dialog/info-dialog.component';
import {CookieBannerComponent} from './cookie-banner/cookie-banner.component';
import {ExitConfirmComponent} from './exit-confirm/exit-confirm.component';
import {YoutubeVideoPopupComponent} from './youtube-video-popup/youtube-video-popup.component';
import {MatButtonModule} from '@angular/material/button';
import {InfoHintComponent} from './info-hint/info-hint.component';

@NgModule({
  declarations: [
    ImageDefaultDirective,
    DataPickerComponent,
    DisableControlDirective,
    PercentPipe,
    PercentFormatterDirective,
    CircleProgressbarComponent,
    PercentInputComponent,
    SafePipe,
    BusyIndicatorComponent,
    InfoDialogComponent,
    CookieBannerComponent,
    ExitConfirmComponent,
    YoutubeVideoPopupComponent,
    InfoHintComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    TranslateModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatProgressSpinnerModule,
    DatepickerCustomHeaderModule,
    MatOptionModule,
    MatSelectModule,
    MatDialogModule,
    MatButtonModule
  ],
  exports: [
    ImageDefaultDirective,
    DataPickerComponent,
    DisableControlDirective,
    PercentPipe,
    PercentFormatterDirective,
    CircleProgressbarComponent,
    PercentInputComponent,
    SafePipe,
    BusyIndicatorComponent,
    InfoDialogComponent,
    CookieBannerComponent,
    YoutubeVideoPopupComponent,
    InfoHintComponent
  ]
})
export class SharedComponentModule {
}
